export default "__VITE_ASSET__6a556b42__"